import React, { useState, useId } from 'react';
import { useAuth } from '../context/AuthContext';
import { API_BASE_URL } from '../config';
import './ImageInput.css';

export default function ImageInput({ label, value, onChange, placeholder = '/uploads/products/your-image.jpg', name }) {
  const { authenticatedFetch } = useAuth();
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const reactId = useId();
  const urlId = `${reactId}-url`;
  const fileId = `${reactId}-file`;

  async function handleFileChange(e) {
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    setUploading(true);
    setError('');

    try {
      const body = new FormData();
      body.append('image', file);
      const res = await authenticatedFetch(`${API_BASE_URL}/api/upload/image`, {
        method: 'POST',
        body,
      });
      if (!res.ok) throw new Error('Upload failed');
      const data = await res.json();
      onChange(`${API_BASE_URL}${data.url}`);
    } catch (err) {
      setError('Failed to upload image');
    } finally {
      setUploading(false);
      // Reset the file input so re-uploading the same file fires onChange again.
      e.target.value = '';
    }
  }

  return (
    <div className="image-input">
      <label htmlFor={urlId}>{label} URL</label>
      <input
        id={urlId}
        type="text"
        name={name}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />

      <label htmlFor={fileId}>Upload {label}</label>
      <input
        id={fileId}
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        disabled={uploading}
      />
      <span className="image-input-hint">Accepts JPG, PNG, GIF, WebP, and SVG.</span>
      {uploading && <span className="image-input-status">Uploading…</span>}
      {error && <span className="image-input-error">{error}</span>}

      {value && (
        <div className="image-input-preview">
          <img src={value} alt={`${label} preview`} />
        </div>
      )}
    </div>
  );
}
